import { call } from "redux-saga/effects";
import sendEvent from "./sendEvent";

export default function* sendDepositClickedEvent() {
  yield call(sendEvent, "poker-web", "depositClicked", ["Log"]);
}
